
import { Component, Vue } from "vue-property-decorator";
import { Signup } from "@/models/signup";
import Axios from "axios";
import { API_STORE } from "@/config";
import {
  getClientInfo,
  validateChildrenComponentForms,
  EventBus,
  getAPIAuthorizedHeader,
} from "@/services/common";
import { updateClientLogo } from "@/services/auth";

@Component({})
export default class SignUpComponent extends Vue {
  public signup = new Signup();
  public imageSrc = null;
  public imageFile = null;
  public emailExist = false;
  public showPassword = false;
  public subdomainExist = false;
  public disableSubmitbutton = false;

  public fileChangeEvent(event) {
    this.imageSrc = URL.createObjectURL(event.target.files[0]);
    this.imageFile = event.target.files[0];
  }

  public async validateAndSignUp() {
      this.disableSubmitbutton = true;
      this.$showLoader(true);
      /**
       * This will execute the validateAll fuction in all the child component
       * returning the state of validation whether it is valid or invalid
       */
      let childrensValid = await validateChildrenComponentForms(this.$children);
      let formValid = await this.$validator.validateAll();

      if (!formValid || !childrensValid) {
        this.disableSubmitbutton = false;
        this.$showLoader(false);
        return;
      }

      let formData = new FormData();

      this.signup.subdomain = this.signup.subdomain.toLowerCase();
      this.signup["portalDetailUpdate"] = true;
      formData.append("file", this.imageFile);
      formData.append("jsonData", JSON.stringify(this.signup));

      let response = await Axios.post(
        API_STORE.CONFIG + "updateUser",
        formData,
        { headers: getAPIAuthorizedHeader() }
      );
      this.$showLoader(false);
      this.disableSubmitbutton = false;
      if(response) {
        this.$snotify.success(response.data.message);
        this.getClientProfile();
      }
  }

  public deleteImage() {
    this.imageFile = null;
    this.imageSrc = null;
    let remoteSrc = !!this.signup.imageInfo;
    if (remoteSrc) this.signup["imageDeleted"] = true;
  }

  public async getClientProfile() {
      let data = await getClientInfo();
      updateClientLogo(data);
      this.signup = data.clientInfo;
      let info = this.signup.imageInfo;
      this.imageSrc =
        info.length > 0 && info[0].path
          ? this.$AWS_S3_URL + this.signup.imageInfo[0].path
          : null;
      /* Emit data when portal update */
      EventBus.$emit("updateClientInfo", data);
  }

  mounted() {
    this.getClientProfile();
  }
}
